  <template>
    <div class="flex flex-col divide-y flex-grow">
      <div>
        <div class="py-8 sm:max-w-136">
          <div class="flex flex-row flex-wrap -m-4">
            <div class="m-4 flex-grow sm:flex-grow-0">
              <div class="input-group min-w-64">
                <label>Страна телефона</label>
                <Select
                  placeholder="Выберите страну"
                  :label="'displayName'"
                  :options="phoneCountries"
                  :searchable="true"
                  :filterable="true"
                  :value="payload.phoneCountry"
                  @input="onPhoneCountryChange"/>
              </div>
            </div>

            <div class="m-4 flex-grow sm:flex-grow-0">
              <Input
                :classes="[
                  'border-geyser',
                  'min-w-64',
                ]"
                label="Телефон"
                :placeholder="phonePlaceholder"
                :invalid="$v.payload.phone.$dirty && $v.payload.phone.$invalid"
                :inputmask="{
                  mask: '9{1,15}',
                  placeholder: '',
                  showMaskOnHover: false,
                  showMaskOnFocus: false,
                }"
                v-model="payload.phoneLocal"/>
              <span class="text-xs text-muted">
                В заявку будет передан номер:
                {{ payload.phone || '—' }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="py-8 sm:max-w-136">
          <div class="flex flex-row flex-wrap -m-4">
            <div class="m-4 flex-grow w-full">
              <div
                class="input-group min-w-64"
                v-if="!individual">
                <label>Название организации или ИНН</label>
                <Select
                  placeholder="Введите название организации или ИНН"
                  label="inn"
                  :searchable="true"
                  :filterable="false"
                  :options="companies"
                  :clear-search-on-blur="() => false"
                  :invalid="$v.payload.inn.$dirty && $v.payload.inn.$invalid"
                  @search="onCompanySearch"
                  @input="onCompanyChange"
                  v-model="payload.company">
                  <template v-slot:option="props">
                    <div class="flex flex-col group">
                      <span class="text-sm group-hover:text-primary">
                        {{ props.name }}
                      </span>
                      <div class="flex flex-row space-x-4 text-xs">
                        <span>ИНН: {{ props.inn }}</span>
                      </div>
                    </div>
                  </template>
                  <template v-slot:no-options>
                    <div class="py-2 text-14px leading-16px">
                      Введите название организации или ИНН
                    </div>
                  </template>
                </Select>
              </div>

              <div v-else class="flex flex-col">
                <Input
                  :classes="[
                    'border-geyser',
                    'min-w-64',
                  ]"
                  :inputmask="{
                    mask: '999999999999',
                    placeholder: '',
                    showMaskOnHover: false,
                    showMaskOnFocus: false,
                  }"
                  label="ИНН"
                  placeholder="Введите ИНН"
                  v-model="payload.inn"/>
                <span class="text-xs text-muted">
                  Обязательно для Самозанятых, опционально для ФЛ
                </span>
              </div>
            </div>

            <div class="m-4 flex-grow sm:flex-grow-0">
              <div class="input-group min-w-64">
                <label>Тип организации</label>
                <Select
                  placeholder="Выберите тип организации"
                  :disabled="true"
                  :options="legalTypes"
                  :value="payload.legalType"
                  :invalid="$v.payload.legalType.$dirty
                    && $v.payload.legalType.$invalid"
                  @input="onLegalTypeChange"/>
              </div>
            </div>

            <div class="m-4 flex-grow sm:flex-grow-0">
              <Input
                :classes="[
                  'border-geyser',
                  {
                    'bg-geyser': !individual,
                  },
                  'min-w-64',
                ]"
                label="Дата регистрации"
                placeholder="ДД-ММ-ГГГГ"
                :inputmask="{
                  alias: 'datetime',
                  inputFormat: 'dd-mm-yyyy',
                  outputFormat: 'yyyy-mm-dd',
                  placeholder: '_',
                  showMaskOnHover: false,
                  showMaskOnFocus: false,
                  onBeforeMask: (value) => value.split('-').reverse().join('-'),
                }"
                :disabled="!individual"
                v-model="payload.registrationDate"/>
            </div>

            <div class="m-4 flex-grow">
              <Input
                :classes="[
                  'border-geyser',
                  {
                    'bg-geyser': !individual,
                  },
                  'min-w-64',
                ]"
                :label="!individual ? 'Название компании' : 'ФИО'"
                :placeholder="!individual ? 'Введите название компании' : 'Введите ФИО'"
                :disabled="!individual"
                :invalid="individual && isNameInvalid"
                v-model="payload.name"/>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="py-8 sm:max-w-136">
          <div class="flex flex-row flex-wrap -m-4">
            <div class="m-4 flex-grow">
              <div class="input-group min-w-64">
                <label>Страна</label>
                <Select
                  placeholder="Выберите страну"
                  :label="'name'"
                  :options="countries"
                  :value="selectedCountry"
                  :invalid="$v.payload.country.$dirty
                    && $v.payload.country.$invalid"
                  @input="onCountryChange"/>
              </div>
            </div>

            <div class="m-4 flex-grow">
              <div class="input-group min-w-64">
                <label>Регион</label>
                <Select
                  placeholder="Выберите регион"
                  :label="'name'"
                  :options="regions"
                  :searchable="true"
                  :filterable="true"
                  :value="selectedRegion"
                  :invalid="$v.payload.region.$dirty
                    && $v.payload.region.$invalid"
                  @input="onRegionChange"/>
              </div>
            </div>

            <div class="m-4 flex-grow">
              <div class="input-group min-w-64">
                <label>Город / населённый пункт</label>
                <Select
                  placeholder="Выберите город или ближайший населённый пункт"
                  :label="'name'"
                  :options="cities"
                  :searchable="true"
                  :filterable="true"
                  :disabled="!payload.region || citiesLoading || !cities.length"
                  :value="selectedCity"
                  :invalid="$v.payload.city.$dirty && $v.payload.city.$invalid"
                  @input="onCityChange"/>
                <span class="text-xs text-muted">
                  Если не нашли свой город или населённый пункт в списке —
                  выберите ближайший к вам.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="py-8 sm:max-w-136">
          <div
            class="rounded-lg border p-5 flex flex-col space-y-3"
            :class="regionalDemandContainerClass">
            <div
              class="
                flex flex-col md:flex-row md:items-start md:justify-between
                md:space-x-6 space-y-3 md:space-y-0
              ">
              <div
                class="
                  flex flex-col sm:flex-row sm:items-start
                  sm:space-x-4 space-y-3 sm:space-y-0
                ">
                <div
                  class="iwaly-traffic-light"
                  aria-label="Светофор спроса iWALY">
                  <span
                    v-for="lamp in regionalTrafficLightLamps"
                    :key="lamp.key"
                    class="iwaly-traffic-light__lamp"
                    :class="lamp.className"/>
                </div>

                <div class="flex flex-col space-y-2">
                <span
                  class="
                    text-12px leading-16px font-semibold uppercase
                    tracking-wide
                  "
                  :class="regionalDemandBadgeClass">
                  {{ regionalDemandBadgeText }}
                </span>

                <strong class="text-18px leading-22px text-primary">
                  {{ regionalDemandTitle }}
                </strong>

                <p class="text-14px leading-20px text-inverse">
                  {{ regionalDemandMessage }}
                </p>

                <p class="text-13px leading-18px text-muted">
                  Для коммерческих направлений это предварительная оценка:
                  после отправки заявки мы отдельно проверим локацию, услуги
                  и текущую потребность. Подключение не гарантируется.
                </p>
              </div>
              </div>

              <div
                v-if="regionalDemandStatusPending"
                class="text-13px leading-18px text-muted flex-shrink-0">
                Анализируем регион…
              </div>
            </div>

            <div
              v-if="regionalDemandMetrics.length"
              class="iwaly-demand-metrics">
              <div class="iwaly-demand-metrics__title">
                Предварительная оценка iWALY
              </div>

              <div class="iwaly-demand-metrics__list">
                <div
                  v-for="metric in regionalDemandMetrics"
                  :key="metric.label"
                  class="iwaly-demand-metrics__row">
                  <span class="iwaly-demand-metrics__label">
                    {{ metric.label }}
                  </span>
                  <strong class="iwaly-demand-metrics__value">
                    {{ metric.value }}
                  </strong>
                </div>
              </div>

              <p class="iwaly-demand-metrics__note">
                {{ regionalDemandPromotionNote }}
              </p>
            </div>

            <div
              v-if="regionalDemandStatusError"
              class="iwaly-demand-helper">
              Не удалось автоматически получить предварительный статус.
              Заявку всё равно можно продолжить: после выбора услуг мы
              проверим регион и направления вручную.
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col lg:flex-row">
        <div class="py-8 sm:max-w-136">
          <div class="flex flex-row flex-wrap -m-4">
            <div
              class="m-4 flex-grow"
              v-if="!individual">
              <Input
                :classes="[
                  'border-geyser',
                  'min-w-64',
                ]"
                label="ФИО контактного лица"
                placeholder="Введите ФИО контактного лица"
                :invalid="$v.payload.contactName.$dirty
                  && $v.payload.contactName.$invalid"
                v-model="payload.contactName"/>
            </div>

            <div class="m-4 flex-grow">
              <Input
                :classes="[
                  'border-geyser',
                  'min-w-64',
                ]"
                label="Email"
                placeholder="Введите email"
                :invalid="$v.payload.email.$dirty && $v.payload.email.$invalid"
                v-model="payload.email"/>
            </div>

            <div
              class="m-4 flex-grow"
              v-if="!individual">
              <Input
                :classes="[
                  'border-geyser',
                  'min-w-64',
                ]"
                label="Телефон контактного лица"
                placeholder="Введите телефон контактного лица"
                :invalid="$v.payload.contactPhone.$dirty
                  && $v.payload.contactPhone.$invalid"
                :inputmask="{
                  mask: '+9{1,15}',
                  placeholder: '',
                  showMaskOnHover: true,
                  showMaskOnFocus: true,
                }"
                v-model="payload.contactPhone"/>
            </div>

            <div class="m-4 flex-grow">
              <Input
                :classes="[
                  'border-geyser',
                  'min-w-64',
                ]"
                type="password"
                label="Пароль"
                placeholder="Введите пароль"
                :invalid="$v.payload.password.$dirty
                  && $v.payload.password.$invalid"
                v-model="payload.password"/>
              <span class="text-xs text-muted">
                Пример пароля: Temp1234
              </span>
            </div>

            <div class="m-4 flex-grow w-full">
              <Input
                :classes="[
                  'border-geyser',
                  'min-w-64',
                ]"
                :textarea="true"
                :rows="4"
                label="Комментарий"
                :invalid="$v.payload.comment.$dirty
                  && $v.payload.comment.$invalid"
                :placeholder="[
                  'Опыт, наличие транспорта, удобное время для связи,',
                  'ссылки на сайт/портфолио, дополнительные сведения',
                ].join(' ')"
                v-model="payload.comment"/>
            </div>
          </div>
        </div>

        <div class="
          py-0 sm:py-8 flex flex-row flex-grow items-end
          justify-center sm:justify-end space-x-6
        ">
          <button
            class="
              btn bg-primary border-solid border-primary
              text-white w-64 flex-grow sm:flex-grow-0
            "
            @click="onNext()">Продолжить</button>
        </div>
      </div>
    </div>
  </template>

<script>
import _ from 'lodash';
import { mapState, mapActions, mapGetters } from 'vuex';
import { required, email } from 'vuelidate/lib/validators';
import Input from '@/components/global/Input.vue';
import Select from '@/components/global/Select.vue';
import { districts, contractorDemandStatus } from '@/api/data';

const makePhoneCountry = (iso, name, dialCode, flag) => ({
  iso,
  name,
  dialCode,
  flag,
  displayName: `${flag} ${name} +${dialCode}`,
});

const PHONE_COUNTRIES_PRIORITY = [
  makePhoneCountry('RU', 'Россия', '7', '🇷🇺'),
  makePhoneCountry('BY', 'Беларусь', '375', '🇧🇾'),
  makePhoneCountry('KZ', 'Казахстан', '7', '🇰🇿'),
  makePhoneCountry('AM', 'Армения', '374', '🇦🇲'),
  makePhoneCountry('GE', 'Грузия', '995', '🇬🇪'),
  makePhoneCountry('AZ', 'Азербайджан', '994', '🇦🇿'),
  makePhoneCountry('UZ', 'Узбекистан', '998', '🇺🇿'),
  makePhoneCountry('KG', 'Кыргызстан', '996', '🇰🇬'),
  makePhoneCountry('TJ', 'Таджикистан', '992', '🇹🇯'),
  makePhoneCountry('MD', 'Молдова', '373', '🇲🇩'),
  makePhoneCountry('UA', 'Украина', '380', '🇺🇦'),
  makePhoneCountry('TR', 'Турция', '90', '🇹🇷'),
  makePhoneCountry('DE', 'Германия', '49', '🇩🇪'),
  makePhoneCountry('IL', 'Израиль', '972', '🇮🇱'),
  makePhoneCountry('US', 'США', '1', '🇺🇸'),
];

const PHONE_COUNTRIES_OTHER = [
  makePhoneCountry('AU', 'Австралия', '61', '🇦🇺'),
  makePhoneCountry('AT', 'Австрия', '43', '🇦🇹'),
  makePhoneCountry('AL', 'Албания', '355', '🇦🇱'),
  makePhoneCountry('DZ', 'Алжир', '213', '🇩🇿'),
  makePhoneCountry('AS', 'Американское Самоа', '1684', '🇦🇸'),
  makePhoneCountry('AD', 'Андорра', '376', '🇦🇩'),
  makePhoneCountry('AO', 'Ангола', '244', '🇦🇴'),
  makePhoneCountry('AI', 'Ангилья', '1264', '🇦🇮'),
  makePhoneCountry('AG', 'Антигуа и Барбуда', '1268', '🇦🇬'),
  makePhoneCountry('AR', 'Аргентина', '54', '🇦🇷'),
  makePhoneCountry('AW', 'Аруба', '297', '🇦🇼'),
  makePhoneCountry('AF', 'Афганистан', '93', '🇦🇫'),
  makePhoneCountry('BS', 'Багамы', '1242', '🇧🇸'),
  makePhoneCountry('BD', 'Бангладеш', '880', '🇧🇩'),
  makePhoneCountry('BB', 'Барбадос', '1246', '🇧🇧'),
  makePhoneCountry('BH', 'Бахрейн', '973', '🇧🇭'),
  makePhoneCountry('BZ', 'Белиз', '501', '🇧🇿'),
  makePhoneCountry('BE', 'Бельгия', '32', '🇧🇪'),
  makePhoneCountry('BJ', 'Бенин', '229', '🇧🇯'),
  makePhoneCountry('BM', 'Бермуды', '1441', '🇧🇲'),
  makePhoneCountry('BG', 'Болгария', '359', '🇧🇬'),
  makePhoneCountry('BO', 'Боливия', '591', '🇧🇴'),
  makePhoneCountry('BA', 'Босния и Герцеговина', '387', '🇧🇦'),
  makePhoneCountry('BW', 'Ботсвана', '267', '🇧🇼'),
  makePhoneCountry('BR', 'Бразилия', '55', '🇧🇷'),
  makePhoneCountry('BN', 'Бруней', '673', '🇧🇳'),
  makePhoneCountry('BF', 'Буркина-Фасо', '226', '🇧🇫'),
  makePhoneCountry('BI', 'Бурунди', '257', '🇧🇮'),
  makePhoneCountry('BT', 'Бутан', '975', '🇧🇹'),
  makePhoneCountry('VU', 'Вануату', '678', '🇻🇺'),
  makePhoneCountry('GB', 'Великобритания', '44', '🇬🇧'),
  makePhoneCountry('HU', 'Венгрия', '36', '🇭🇺'),
  makePhoneCountry('VE', 'Венесуэла', '58', '🇻🇪'),
  makePhoneCountry('VG', 'Виргинские острова, Британия', '1284', '🇻🇬'),
  makePhoneCountry('VI', 'Виргинские острова, США', '1340', '🇻🇮'),
  makePhoneCountry('VN', 'Вьетнам', '84', '🇻🇳'),
  makePhoneCountry('GA', 'Габон', '241', '🇬🇦'),
  makePhoneCountry('HT', 'Гаити', '509', '🇭🇹'),
  makePhoneCountry('GY', 'Гайана', '592', '🇬🇾'),
  makePhoneCountry('GM', 'Гамбия', '220', '🇬🇲'),
  makePhoneCountry('GH', 'Гана', '233', '🇬🇭'),
  makePhoneCountry('GP', 'Гваделупа', '590', '🇬🇵'),
  makePhoneCountry('GT', 'Гватемала', '502', '🇬🇹'),
  makePhoneCountry('GN', 'Гвинея', '224', '🇬🇳'),
  makePhoneCountry('GW', 'Гвинея-Бисау', '245', '🇬🇼'),
  makePhoneCountry('GI', 'Гибралтар', '350', '🇬🇮'),
  makePhoneCountry('HN', 'Гондурас', '504', '🇭🇳'),
  makePhoneCountry('HK', 'Гонконг', '852', '🇭🇰'),
  makePhoneCountry('GD', 'Гренада', '1473', '🇬🇩'),
  makePhoneCountry('GL', 'Гренландия', '299', '🇬🇱'),
  makePhoneCountry('GR', 'Греция', '30', '🇬🇷'),
  makePhoneCountry('GU', 'Гуам', '1671', '🇬🇺'),
  makePhoneCountry('DK', 'Дания', '45', '🇩🇰'),
  makePhoneCountry('CD', 'ДР Конго', '243', '🇨🇩'),
  makePhoneCountry('DJ', 'Джибути', '253', '🇩🇯'),
  makePhoneCountry('DM', 'Доминика', '1767', '🇩🇲'),
  makePhoneCountry('DO', 'Доминиканская Республика', '1809', '🇩🇴'),
  makePhoneCountry('EG', 'Египет', '20', '🇪🇬'),
  makePhoneCountry('ZM', 'Замбия', '260', '🇿🇲'),
  makePhoneCountry('ZW', 'Зимбабве', '263', '🇿🇼'),
  makePhoneCountry('IN', 'Индия', '91', '🇮🇳'),
  makePhoneCountry('ID', 'Индонезия', '62', '🇮🇩'),
  makePhoneCountry('JO', 'Иордания', '962', '🇯🇴'),
  makePhoneCountry('IQ', 'Ирак', '964', '🇮🇶'),
  makePhoneCountry('IR', 'Иран', '98', '🇮🇷'),
  makePhoneCountry('IE', 'Ирландия', '353', '🇮🇪'),
  makePhoneCountry('IS', 'Исландия', '354', '🇮🇸'),
  makePhoneCountry('ES', 'Испания', '34', '🇪🇸'),
  makePhoneCountry('IT', 'Италия', '39', '🇮🇹'),
  makePhoneCountry('YE', 'Йемен', '967', '🇾🇪'),
  makePhoneCountry('CV', 'Кабо-Верде', '238', '🇨🇻'),
  makePhoneCountry('KH', 'Камбоджа', '855', '🇰🇭'),
  makePhoneCountry('CM', 'Камерун', '237', '🇨🇲'),
  makePhoneCountry('CA', 'Канада', '1', '🇨🇦'),
  makePhoneCountry('QA', 'Катар', '974', '🇶🇦'),
  makePhoneCountry('KE', 'Кения', '254', '🇰🇪'),
  makePhoneCountry('CY', 'Кипр', '357', '🇨🇾'),
  makePhoneCountry('CN', 'Китай', '86', '🇨🇳'),
  makePhoneCountry('CO', 'Колумбия', '57', '🇨🇴'),
  makePhoneCountry('KM', 'Коморы', '269', '🇰🇲'),
  makePhoneCountry('CG', 'Конго', '242', '🇨🇬'),
  makePhoneCountry('CR', 'Коста-Рика', '506', '🇨🇷'),
  makePhoneCountry('CI', 'Кот-д’Ивуар', '225', '🇨🇮'),
  makePhoneCountry('CU', 'Куба', '53', '🇨🇺'),
  makePhoneCountry('KW', 'Кувейт', '965', '🇰🇼'),
  makePhoneCountry('LA', 'Лаос', '856', '🇱🇦'),
  makePhoneCountry('LV', 'Латвия', '371', '🇱🇻'),
  makePhoneCountry('LS', 'Лесото', '266', '🇱🇸'),
  makePhoneCountry('LR', 'Либерия', '231', '🇱🇷'),
  makePhoneCountry('LB', 'Ливан', '961', '🇱🇧'),
  makePhoneCountry('LY', 'Ливия', '218', '🇱🇾'),
  makePhoneCountry('LT', 'Литва', '370', '🇱🇹'),
  makePhoneCountry('LI', 'Лихтенштейн', '423', '🇱🇮'),
  makePhoneCountry('LU', 'Люксембург', '352', '🇱🇺'),
  makePhoneCountry('MU', 'Маврикий', '230', '🇲🇺'),
  makePhoneCountry('MR', 'Мавритания', '222', '🇲🇷'),
  makePhoneCountry('MG', 'Мадагаскар', '261', '🇲🇬'),
  makePhoneCountry('MO', 'Макао', '853', '🇲🇴'),
  makePhoneCountry('MW', 'Малави', '265', '🇲🇼'),
  makePhoneCountry('MY', 'Малайзия', '60', '🇲🇾'),
  makePhoneCountry('ML', 'Мали', '223', '🇲🇱'),
  makePhoneCountry('MV', 'Мальдивы', '960', '🇲🇻'),
  makePhoneCountry('MT', 'Мальта', '356', '🇲🇹'),
  makePhoneCountry('MA', 'Марокко', '212', '🇲🇦'),
  makePhoneCountry('MQ', 'Мартиника', '596', '🇲🇶'),
  makePhoneCountry('MX', 'Мексика', '52', '🇲🇽'),
  makePhoneCountry('MZ', 'Мозамбик', '258', '🇲🇿'),
  makePhoneCountry('MC', 'Монако', '377', '🇲🇨'),
  makePhoneCountry('MN', 'Монголия', '976', '🇲🇳'),
  makePhoneCountry('MS', 'Монтсеррат', '1664', '🇲🇸'),
  makePhoneCountry('MM', 'Мьянма', '95', '🇲🇲'),
  makePhoneCountry('NA', 'Намибия', '264', '🇳🇦'),
  makePhoneCountry('NP', 'Непал', '977', '🇳🇵'),
  makePhoneCountry('NE', 'Нигер', '227', '🇳🇪'),
  makePhoneCountry('NG', 'Нигерия', '234', '🇳🇬'),
  makePhoneCountry('NL', 'Нидерланды', '31', '🇳🇱'),
  makePhoneCountry('NI', 'Никарагуа', '505', '🇳🇮'),
  makePhoneCountry('NZ', 'Новая Зеландия', '64', '🇳🇿'),
  makePhoneCountry('NO', 'Норвегия', '47', '🇳🇴'),
  makePhoneCountry('AE', 'ОАЭ', '971', '🇦🇪'),
  makePhoneCountry('OM', 'Оман', '968', '🇴🇲'),
  makePhoneCountry('PK', 'Пакистан', '92', '🇵🇰'),
  makePhoneCountry('PS', 'Палестина', '970', '🇵🇸'),
  makePhoneCountry('PA', 'Панама', '507', '🇵🇦'),
  makePhoneCountry('PG', 'Папуа — Новая Гвинея', '675', '🇵🇬'),
  makePhoneCountry('PY', 'Парагвай', '595', '🇵🇾'),
  makePhoneCountry('PE', 'Перу', '51', '🇵🇪'),
  makePhoneCountry('PL', 'Польша', '48', '🇵🇱'),
  makePhoneCountry('PT', 'Португалия', '351', '🇵🇹'),
  makePhoneCountry('PR', 'Пуэрто-Рико', '1787', '🇵🇷'),
  makePhoneCountry('KR', 'Республика Корея', '82', '🇰🇷'),
  makePhoneCountry('RE', 'Реюньон', '262', '🇷🇪'),
  makePhoneCountry('RW', 'Руанда', '250', '🇷🇼'),
  makePhoneCountry('RO', 'Румыния', '40', '🇷🇴'),
  makePhoneCountry('SV', 'Сальвадор', '503', '🇸🇻'),
  makePhoneCountry('WS', 'Самоа', '685', '🇼🇸'),
  makePhoneCountry('SM', 'Сан-Марино', '378', '🇸🇲'),
  makePhoneCountry('SA', 'Саудовская Аравия', '966', '🇸🇦'),
  makePhoneCountry('SZ', 'Свазиленд', '268', '🇸🇿'),
  makePhoneCountry('SC', 'Сейшелы', '248', '🇸🇨'),
  makePhoneCountry('SN', 'Сенегал', '221', '🇸🇳'),
  makePhoneCountry('VC', 'Сент-Винсент и Гренадины', '1784', '🇻🇨'),
  makePhoneCountry('KN', 'Сент-Китс и Невис', '1869', '🇰🇳'),
  makePhoneCountry('LC', 'Сент-Люсия', '1758', '🇱🇨'),
  makePhoneCountry('RS', 'Сербия', '381', '🇷🇸'),
  makePhoneCountry('SG', 'Сингапур', '65', '🇸🇬'),
  makePhoneCountry('SY', 'Сирия', '963', '🇸🇾'),
  makePhoneCountry('SK', 'Словакия', '421', '🇸🇰'),
  makePhoneCountry('SI', 'Словения', '386', '🇸🇮'),
  makePhoneCountry('SO', 'Сомали', '252', '🇸🇴'),
  makePhoneCountry('SD', 'Судан', '249', '🇸🇩'),
  makePhoneCountry('SR', 'Суринам', '597', '🇸🇷'),
  makePhoneCountry('SL', 'Сьерра-Леоне', '232', '🇸🇱'),
  makePhoneCountry('TH', 'Таиланд', '66', '🇹🇭'),
  makePhoneCountry('TW', 'Тайвань', '886', '🇹🇼'),
  makePhoneCountry('TZ', 'Танзания', '255', '🇹🇿'),
  makePhoneCountry('TG', 'Того', '228', '🇹🇬'),
  makePhoneCountry('TO', 'Тонга', '676', '🇹🇴'),
  makePhoneCountry('TT', 'Тринидад и Тобаго', '1868', '🇹🇹'),
  makePhoneCountry('TN', 'Тунис', '216', '🇹🇳'),
  makePhoneCountry('TM', 'Туркменистан', '993', '🇹🇲'),
  makePhoneCountry('UG', 'Уганда', '256', '🇺🇬'),
  makePhoneCountry('UY', 'Уругвай', '598', '🇺🇾'),
  makePhoneCountry('FO', 'Фарерские острова', '298', '🇫🇴'),
  makePhoneCountry('FJ', 'Фиджи', '679', '🇫🇯'),
  makePhoneCountry('PH', 'Филиппины', '63', '🇵🇭'),
  makePhoneCountry('FI', 'Финляндия', '358', '🇫🇮'),
  makePhoneCountry('FR', 'Франция', '33', '🇫🇷'),
  makePhoneCountry('GF', 'Французская Гвиана', '594', '🇬🇫'),
  makePhoneCountry('PF', 'Французская Полинезия', '689', '🇵🇫'),
  makePhoneCountry('HR', 'Хорватия', '385', '🇭🇷'),
  makePhoneCountry('CF', 'ЦАР', '236', '🇨🇫'),
  makePhoneCountry('TD', 'Чад', '235', '🇹🇩'),
  makePhoneCountry('ME', 'Черногория', '382', '🇲🇪'),
  makePhoneCountry('CZ', 'Чехия', '420', '🇨🇿'),
  makePhoneCountry('CL', 'Чили', '56', '🇨🇱'),
  makePhoneCountry('CH', 'Швейцария', '41', '🇨🇭'),
  makePhoneCountry('SE', 'Швеция', '46', '🇸🇪'),
  makePhoneCountry('LK', 'Шри-Ланка', '94', '🇱🇰'),
  makePhoneCountry('EC', 'Эквадор', '593', '🇪🇨'),
  makePhoneCountry('GQ', 'Экваториальная Гвинея', '240', '🇬🇶'),
  makePhoneCountry('ER', 'Эритрея', '291', '🇪🇷'),
  makePhoneCountry('EE', 'Эстония', '372', '🇪🇪'),
  makePhoneCountry('ET', 'Эфиопия', '251', '🇪🇹'),
  makePhoneCountry('ZA', 'ЮАР', '27', '🇿🇦'),
  makePhoneCountry('JM', 'Ямайка', '1876', '🇯🇲'),
  makePhoneCountry('JP', 'Япония', '81', '🇯🇵'),
];

const PHONE_COUNTRIES = [
  ...PHONE_COUNTRIES_PRIORITY,
  ...PHONE_COUNTRIES_OTHER,
];

const [DEFAULT_PHONE_COUNTRY] = PHONE_COUNTRIES_PRIORITY;

export default {
  components: {
    Input,
    Select,
  },
  data() {
    return {
      isRestoring: false,
      cities: [],
      citiesLoading: false,
      regionalDemandStatus: null,
      regionalDemandStatusPending: false,
      regionalDemandStatusError: false,
      regionalDemandStatusRequestSeq: 0,
      payload: {
        country: null,
        region: null,
        city: null,
        legalType: { value: 'individual', label: 'Самозанятый или ФЛ' },
        name: '',
        inn: '',
        contactName: '',
        contactPhone: '',
        email: '',
        phone: '',
        phoneLocal: '',
        phoneCountry: DEFAULT_PHONE_COUNTRY,
        phoneCountryIso: DEFAULT_PHONE_COUNTRY.iso,
        phoneCountryName: DEFAULT_PHONE_COUNTRY.name,
        phoneDialCode: DEFAULT_PHONE_COUNTRY.dialCode,
        password: '',
        cityName: '',
        comment: '',
        registrationDate: '',
        company: null,
      },
    };
  },
  validations() {
    const validatePassword = (value) => {
      const regexp = /(?=^.{6,}$)(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).*$/;
      return regexp.test(value);
    };

    const validatePhone = (value) => /^\+(\d{1,15})$/.test(value);

    if (this.individual) {
      return {
        payload: {
          country: { required },
          region: { required },
          city: { required },
          legalType: { required },
          name: { required },
          email: { required, email },
          phone: {
            required,
            phone: (value) => validatePhone(value),
          },
          password: {
            required,
            strong: (value) => validatePassword(value),
          },
          comment: { required },
        },
      };
    }

    return {
      payload: {
        country: { required },
        region: { required },
        city: { required },
        legalType: { required },
        name: { required },
        inn: { required },
        contactName: { required },
        contactPhone: {
          required,
          phone: (value) => validatePhone(value),
        },
        email: { required, email },
        phone: {
          required,
          phone: (value) => validatePhone(value),
        },
        password: {
          required,
          strong: (value) => validatePassword(value),
        },
        comment: { required },
        registrationDate: { required },
      },
    };
  },
  computed: {
    ...mapState({
      countries: (state) => state.countries,
      statePayload: (state) => state.payload,
      companies: (state) => state.companies,
    }),
    ...mapGetters({
      regionsGetter: 'regions',
      legalTypes: 'legalTypes',
    }),
    phoneCountries() {
      return PHONE_COUNTRIES;
    },
    phonePlaceholder() {
      const dialCode = _.get(this.payload.phoneCountry, 'dialCode') || '7';

      if (dialCode === '7') {
        return '9991234567';
      }

      return 'Введите номер без кода страны';
    },
    regions() {
      const country = _.get(this.payload.country, 'id');

      if (country) {
        return this.regionsGetter(country);
      }

      return [];
    },
    selectedCountry() {
      const id = _.get(this.payload.country, 'id');

      return this.findById(this.countries, id)
          || this.payload.country
          || null;
    },
    selectedRegion() {
      const id = _.get(this.payload.region, 'id');

      return this.findById(this.regions, id)
          || this.payload.region
          || null;
    },
    selectedCity() {
      const id = _.get(this.payload.city, 'id');

      return this.findById(this.cities, id)
          || this.payload.city
          || null;
    },
    individual() {
      return _.get(this.payload, 'legalType.value') === 'individual';
    },
    isNameInvalid() {
      return this.$v.payload.name.$dirty && this.$v.payload.name.$invalid;
    },
    selectedRegionId() {
      return _.get(this.payload, 'region.id') || null;
    },
    regionalDemandOverall() {
      return _.get(this.regionalDemandStatus, 'overall') || null;
    },
    regionalDemandSignal() {
      return _.get(this.regionalDemandOverall, 'signal') || 'UNKNOWN';
    },
    regionalTrafficLightLamps() {
      return this.trafficLightLamps(this.regionalDemandSignal);
    },
    regionalDemandTitle() {
      if (!this.selectedRegionId) {
        return 'Светофор iWALY по вашему региону';
      }

      return _.get(this.regionalDemandOverall, 'title')
          || 'Предварительный статус спроса по региону';
    },
    regionalDemandMessage() {
      if (!this.selectedRegionId) {
        return [
          'Выберите регион работы — мы сразу покажем предварительную',
          'оценку спроса по ретроспективе iWALY за год. Точный статус',
          'по направлениям появится после выбора категорий услуг.',
        ].join(' ');
      }

      return _.get(this.regionalDemandOverall, 'message')
          || [
            'Мы проверяем ретроспективу iWALY за год, свежую активность',
            'и наличие активных исполнителей заказов.',
          ].join(' ');
    },
    regionalDemandBadgeText() {
      if (this.regionalDemandStatusPending) {
        return 'Анализ спроса';
      }

      return _.get(this.regionalDemandOverall, 'badge') || 'Светофор iWALY';
    },
    regionalDemandContainerClass() {
      switch (this.regionalDemandSignal) {
        case 'RED':
          return 'bg-white border-green-600';
        case 'YELLOW':
          return 'bg-white border-yellow-500';
        case 'GREY':
          return 'bg-white border-geyser';
        case 'GREEN_RESERVE':
          return 'bg-white border-primary';
        default:
          return 'bg-white border-geyser';
      }
    },
    regionalDemandBadgeClass() {
      switch (this.regionalDemandSignal) {
        case 'RED':
          return 'text-green-700';
        case 'YELLOW':
          return 'text-yellow-700';
        case 'GREY':
          return 'text-muted';
        case 'GREEN_RESERVE':
          return 'text-primary';
        default:
          return 'text-muted';
      }
    },
    regionalDemandMetrics() {
      if (!this.regionalDemandOverall) {
        return [];
      }

      const orders365 = _.get(this.regionalDemandOverall, 'orders_365', 0);
      const orders30 = _.get(this.regionalDemandOverall, 'orders_30', 0);
      const activeContractors = _.get(
        this.regionalDemandOverall,
        'actually_active_contractors_365',
        _.get(this.regionalDemandOverall, 'active_contractors', 0),
      );

      return [
        {
          label: 'Спрос за год',
          value: this.ordersYearLevel(orders365),
        },
        {
          label: 'Последние 30 дней',
          value: this.ordersRecentLevel(orders30),
        },
        {
          label: 'Активные исполнители',
          value: this.contractorsLevel(activeContractors),
        },
      ];
    },
    regionalDemandPromotionNote() {
      return [
        'Ваша помощь в информировании людей о сервисе очень ценна.',
      ].join(' ');
    },
  },
  methods: {
    ...mapActions({
      FETCH_REGIONS: 'ACT_FETCH_REGIONS',
      SET_STATE: 'ACT_SET_STATE',
      GET_SUGGESTIONS: 'ACT_GET_SUGGESTIONS',
      SET_SUGGESTION: 'ACT_SET_SUGGESTION',
      ON_LEGAL_TYPE_CHANGE: 'ACT_ON_LEGAL_TYPE_CHANGE',
    }),

    trafficLightLamps(signal) {
      const activeColor = {
        RED: 'green',
        YELLOW: 'yellow',
        GREEN_RESERVE: 'red',
        GREY: 'grey',
      }[signal] || '';

      return ['red', 'yellow', 'green', 'grey'].map((color) => ({
        key: color,
        className: [
          `iwaly-traffic-light__lamp--${color}`,
          activeColor === color ? 'iwaly-traffic-light__lamp--active' : '',
        ].filter(Boolean).join(' '),
      }));
    },

    ordersYearLevel(value) {
      const count = Number(value || 0);

      if (count <= 0) {
        return 'малозаметный';
      }

      if (count <= 5) {
        return 'единичные заказы';
      }

      if (count <= 30) {
        return 'умеренный';
      }

      return 'заметный';
    },

    ordersRecentLevel(value) {
      const count = Number(value || 0);

      if (count <= 0) {
        return 'малозаметная активность';
      }

      if (count <= 2) {
        return 'единичные заказы';
      }

      if (count <= 10) {
        return 'умеренная активность';
      }

      return 'заметная активность';
    },

    contractorsLevel(value) {
      const count = Number(value || 0);

      if (count <= 0) {
        return 'формируется';
      }

      if (count <= 2) {
        return 'мало';
      }

      if (count <= 8) {
        return 'средне';
      }

      return 'много';
    },

    findById(collection, id) {
      if (!id || !Array.isArray(collection)) {
        return null;
      }

      return collection.find(
        (item) => String(item.id) === String(id),
      ) || null;
    },

    onCountryChange(event) {
      if (!event && this.payload.country) {
        return;
      }

      const oldId = _.get(this.payload.country, 'id');
      const newId = _.get(event, 'id');

      if (String(oldId || '') === String(newId || '')) {
        this.payload.country = event || this.payload.country;
        return;
      }

      this.payload.country = event || null;
      this.payload.region = null;
      this.payload.city = null;
      this.payload.cityName = '';
      this.cities = [];
    },

    onRegionChange(event) {
      if (!event && this.payload.region) {
        return;
      }

      const oldId = _.get(this.payload.region, 'id');
      const newId = _.get(event, 'id');

      if (String(oldId || '') === String(newId || '')) {
        this.payload.region = event || this.payload.region;
        return;
      }

      this.payload.region = event || null;
      this.payload.city = null;
      this.payload.cityName = '';

      if (!event) {
        this.cities = [];
      }
    },

    normalizeDigits(value) {
      return String(value || '').replace(/\D/g, '');
    },

    normalizePhone() {
      const country = this.payload.phoneCountry || DEFAULT_PHONE_COUNTRY;
      const { dialCode } = country;
      let local = this.normalizeDigits(this.payload.phoneLocal);

      if (dialCode === '7' && local.length === 11 && local[0] === '8') {
        local = local.slice(1);
      }

      if (local.indexOf(dialCode) === 0) {
        local = local.slice(dialCode.length);
      }

      const phone = local ? `+${dialCode}${local}` : '';

      if (this.payload.phoneLocal !== local) {
        this.payload.phoneLocal = local;
      }

      if (this.payload.phone !== phone) {
        this.payload.phone = phone;
      }

      this.payload.phoneCountryIso = country.iso;
      this.payload.phoneCountryName = country.name;
      this.payload.phoneDialCode = country.dialCode;
    },

    onPhoneCountryChange(event) {
      this.payload.phoneCountry = event || DEFAULT_PHONE_COUNTRY;
      this.normalizePhone();
    },

    normalizeDistricts(data) {
      const raw = _.get(data, 'data') || data || [];

      if (!Array.isArray(raw)) {
        return [];
      }

      return raw
        .map((item) => ({
          id: item.id
              || item.value
              || item.city_id
              || item.district_id
              || '',
          name: item.name
              || item.title
              || item.label
              || item.cityName
              || item.city_name
              || item.districtName
              || item.district_name
              || '',
        }))
        .filter((item) => item.id && item.name);
    },

    async fetchCities(regionId, selectedCity = null) {
      const savedCity = selectedCity || this.payload.city;

      this.cities = [];

      if (!this.isRestoring) {
        this.payload.city = null;
        this.payload.cityName = '';
      }

      if (!regionId) {
        return;
      }

      this.citiesLoading = true;

      try {
        const response = await districts(regionId);
        this.cities = this.normalizeDistricts(response.data);

        const savedCityId = _.get(savedCity, 'id');

        if (savedCityId) {
          const restoredCity = this.cities.find(
            (item) => String(item.id) === String(savedCityId),
          );

          this.payload.city = restoredCity || savedCity;
          this.payload.cityName = _.get(this.payload.city, 'name') || '';
        }
      } catch (error) {
        this.cities = [];
      } finally {
        this.citiesLoading = false;
      }
    },

    onCityChange(event) {
      if (!event && this.payload.city) {
        return;
      }

      this.payload.city = event || null;
      this.payload.cityName = event ? event.name : '';
    },

    onNext() {
      this.normalizePhone();
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$emit('next');
        this.scrollToServicesAfterNext();
        return;
      }

      this.$iwalyNotify.error({
        text: 'Вы не заполнили все обязательные поля или заполнили их неверно.',
      });

      if (!this.$v.payload.password.strong) {
        this.$iwalyNotify.error({
          text: 'Пароль должен содержать не менее 6 знаков, '
              + 'в том числе 1 заглавную букву, 1 строчную и 1 цифру',
        });
      }
    },

    scrollToServicesAfterNext() {
      window.setTimeout(() => {
        this.scrollToServicesSection();
      }, 150);
    },

    scrollToServicesSection() {
      const selectors = [
        '#services-section',
        '#service-categories',
        '.services-section',
        '.service-categories',
        '[data-scroll-target="services"]',
      ];

      const target = selectors
        .map((selector) => document.querySelector(selector))
        .find((element) => Boolean(element));

      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });

        return;
      }

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },

    loadRegionalDemandStatus: _.debounce(function loadRegionalDemandStatus() {
      const regionId = this.selectedRegionId;

      if (!regionId) {
        this.regionalDemandStatus = null;
        this.regionalDemandStatusError = false;
        this.SET_STATE({
          contractorRegionDemandStatus: null,
        });
        return;
      }

      const requestSeq = this.regionalDemandStatusRequestSeq + 1;
      this.regionalDemandStatusRequestSeq = requestSeq;
      this.regionalDemandStatusPending = true;
      this.regionalDemandStatusError = false;

      contractorDemandStatus({ regionId })
        .then((response) => {
          if (requestSeq !== this.regionalDemandStatusRequestSeq) {
            return;
          }

          const data = response.data || null;
          this.regionalDemandStatus = data;
          this.SET_STATE({
            contractorRegionDemandStatus: data,
          });
        })
        .catch(() => {
          if (requestSeq !== this.regionalDemandStatusRequestSeq) {
            return;
          }

          this.regionalDemandStatus = null;
          this.regionalDemandStatusError = true;
          this.SET_STATE({
            contractorRegionDemandStatus: null,
          });
        })
        .finally(() => {
          if (requestSeq === this.regionalDemandStatusRequestSeq) {
            this.regionalDemandStatusPending = false;
          }
        });
    }, 500),

    onCompanySearch(event) {
      this.GET_SUGGESTIONS(event);
    },

    onCompanyChange(event) {
      this.SET_SUGGESTION(event);
    },

    onLegalTypeChange(event) {
      this.payload.legalType = event;

      this.$nextTick().then(() => {
        this.ON_LEGAL_TYPE_CHANGE(event);
      });
    },

    async sync() {
      this.isRestoring = true;

      const savedCountry = this.statePayload.country || this.payload.country;
      const savedRegion = this.statePayload.region || this.payload.region;
      const savedCity = this.statePayload.city || this.payload.city;

      this.payload = {
        ...this.payload,
        ...this.statePayload,
        country: savedCountry,
        region: savedRegion,
        city: savedCity,
        cityName: _.get(savedCity, 'name') || this.statePayload.cityName || '',
      };

      if (!this.payload.phoneCountry) {
        this.payload.phoneCountry = DEFAULT_PHONE_COUNTRY;
      }

      this.normalizePhone();

      const countryId = _.get(this.payload.country, 'id');
      const regionId = _.get(this.payload.region, 'id');

      try {
        if (countryId) {
          await this.FETCH_REGIONS(countryId);

          const restoredCountry = this.findById(this.countries, countryId);

          if (restoredCountry) {
            this.payload.country = restoredCountry;
          }
        }

        if (regionId) {
          const restoredRegion = this.findById(this.regions, regionId);

          if (restoredRegion) {
            this.payload.region = restoredRegion;
          }

          await this.fetchCities(regionId, savedCity);
        }
      } finally {
        this.$nextTick().then(() => {
          this.isRestoring = false;
        });
      }
    },
  },
  watch: {
    payload: {
      handler() {
        this.SET_STATE(_.cloneDeep(this.payload));
      },
      deep: true,
    },
    'payload.phoneLocal': {
      handler() {
        this.normalizePhone();
      },
    },
    'payload.country': {
      handler(value, oldValue) {
        if (this.isRestoring) {
          return;
        }

        const id = _.get(value, 'id');
        const oldId = _.get(oldValue, 'id');

        if (String(id || '') === String(oldId || '')) {
          return;
        }

        if (id) {
          this.FETCH_REGIONS(id);
        }
      },
    },
    'payload.region': {
      handler(value, oldValue) {
        if (this.isRestoring) {
          return;
        }

        const id = _.get(value, 'id');
        const oldId = _.get(oldValue, 'id');

        if (String(id || '') === String(oldId || '')) {
          return;
        }

        if (id) {
          this.fetchCities(id);
        }
      },
    },
    selectedRegionId() {
      this.loadRegionalDemandStatus();
    },
  },
  mounted() {
    this.sync();

    this.$nextTick().then(() => {
      this.loadRegionalDemandStatus();
    });

    this.$eventBus.$on('sync', (event) => {
      this.sync(event);
    });
  },
  beforeDestroy() {
    this.$eventBus.$off('sync');
  },
};
</script>

<style scoped>
.iwaly-traffic-light {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 999px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.08);
  flex-shrink: 0;
}

.iwaly-traffic-light__lamp {
  width: 16px;
  height: 16px;
  border-radius: 999px;
  background: #d1d5db;
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.24);
  opacity: 0.38;
}

.iwaly-traffic-light__lamp--red.iwaly-traffic-light__lamp--active {
  background: #ef4444;
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.14), 0 0 14px rgba(239, 68, 68, 0.55);
  opacity: 1;
}

.iwaly-traffic-light__lamp--yellow.iwaly-traffic-light__lamp--active {
  background: #f59e0b;
  box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.16), 0 0 14px rgba(245, 158, 11, 0.52);
  opacity: 1;
}

.iwaly-traffic-light__lamp--green.iwaly-traffic-light__lamp--active {
  background: #22c55e;
  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.14), 0 0 14px rgba(34, 197, 94, 0.48);
  opacity: 1;
}

.iwaly-traffic-light__lamp--grey.iwaly-traffic-light__lamp--active {
  background: #64748b;
  box-shadow: 0 0 0 4px rgba(100, 116, 139, 0.14), 0 0 14px rgba(100, 116, 139, 0.42);
  opacity: 1;
}

.iwaly-demand-metrics {
  margin-top: 4px;
  padding: 14px 16px;
  border-radius: 14px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
}

.iwaly-demand-metrics__title {
  font-size: 12px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
}

.iwaly-demand-metrics__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
}

.iwaly-demand-metrics__row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
}

.iwaly-demand-metrics__label {
  font-size: 13px;
  line-height: 18px;
  color: #64748b;
}

.iwaly-demand-metrics__value {
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  color: #1f2937;
  text-align: right;
}

.iwaly-demand-metrics__note {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #e5e7eb;
  font-size: 13px;
  line-height: 19px;
  color: #64748b;
}

.iwaly-demand-helper {
  padding: 12px 14px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  font-size: 13px;
  line-height: 19px;
  color: #64748b;
}

@media (max-width: 640px) {
  .iwaly-demand-metrics__row {
    display: block;
  }

  .iwaly-demand-metrics__value {
    display: block;
    margin-top: 2px;
    text-align: left;
  }
}
</style>
